import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "../data/site";

const LINKS = [
    { label: "Home", path: "/", testid: "nav-home-link" },
    { label: "Lawn Care", path: "/lawn-care", testid: "nav-lawn-care-link" },
    { label: "Gutter & Window", path: "/gutter-window-cleaning", testid: "nav-gutter-window-link" },
    { label: "Junk Removal", path: "/junk-removal", testid: "nav-junk-removal-link" },
    { label: "Before & After", path: "/before-after", testid: "nav-before-after-link" },
    { label: "Pricing", path: "/pricing", testid: "nav-pricing-link" },
    { label: "Contact", path: "/contact", testid: "nav-contact-link" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    return (
        <header data-testid="site-header" className="fixed inset-x-0 top-0 z-50 border-b border-forest/10 bg-bone/85 backdrop-blur-md">
            <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
                <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5" onClick={() => setOpen(false)}>
                    <img src="/assets/photos/logo.png" alt="Lawn Busters — Professional Yard Care"
                        className="h-11 w-auto" />
                    <span className="hidden font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-moss sm:inline">Adelaide SA</span>
                </Link>
                <nav className="hidden items-center gap-6 lg:flex">
                    {LINKS.map((l) => (
                        <NavLink key={l.path} to={l.path} data-testid={l.testid}
                            className={({ isActive }) =>
                                `text-sm font-semibold transition-colors hover:text-forest-leaf ${isActive ? "text-forest" : "text-moss"}`}>
                            {l.label}
                        </NavLink>
                    ))}
                    <Link to="/book-now" data-testid="nav-book-now-button"
                        className="rounded-full bg-forest px-5 py-2.5 text-sm font-bold text-bone transition-colors hover:bg-forest-deep">
                        Book Now
                    </Link>
                </nav>
                <button data-testid="nav-mobile-toggle" className="text-ink lg:hidden" onClick={() => setOpen(!open)} aria-label="Toggle menu">
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
            {open && (
                <div data-testid="nav-mobile-menu" className="border-t border-forest/10 bg-bone px-6 py-4 lg:hidden">
                    <div className="flex flex-col gap-3">
                        {LINKS.map((l) => (
                            <NavLink key={l.path} to={l.path} data-testid={`${l.testid}-mobile`} onClick={() => setOpen(false)}
                                className="py-1 text-sm font-semibold text-ink">
                                {l.label}
                            </NavLink>
                        ))}
                        <Link to="/book-now" data-testid="nav-book-now-button-mobile" onClick={() => setOpen(false)}
                            className="mt-2 rounded-full bg-forest px-5 py-3 text-center text-sm font-bold text-bone">
                            Book Now
                        </Link>
                        <a href={BUSINESS.phoneHref} data-testid="nav-phone-mobile" className="flex items-center gap-2 py-1 text-sm font-semibold text-forest">
                            <Phone size={14} /> {BUSINESS.phone}
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
